import "./PhoneFormatModal.scss";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";

const PhoneFormatModal = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const [openModal, setOpenModal] = useState(false);

  const modalContent = {
    ar: {
      title: "تحديث مهم في صيغة أرقام الجوال",
      message: (
        <>
          تم تحديث صيغة جميع أرقام الجوال في النظام لتبدأ بـ{" "}
          <span className="phone-number-example new-format">050</span>
          <br />
          <br />
          <strong>الصيغة القديمة:</strong>
          <br />
          <span className="phone-number-example old-format">966532571702</span>
          <br />
          <span className="arrow-icon">⬇</span>
          <br />
          <strong>الصيغة الجديدة:</strong>
          <br />
          <span className="phone-number-example new-format">0536785505</span>
          <span className="info-note">
            💡 <strong>ملاحظة:</strong> جميع الأرقام المحفوظة في النظام تم تحديثها تلقائياً. 
            لا يلزمك القيام بأي إجراء، فقط استخدم الصيغة الجديدة عند إدخال أرقام جديدة.
          </span>
        </>
      ),
      button: "تمام، فهمت"
    },
    en: {
      title: "Important Phone Format Update",
      message: (
        <>
          All phone numbers in the system have been updated to start with{" "}
          <span className="phone-number-example new-format">050</span>
          <br />
          <br />
          <strong>Old Format:</strong>
          <br />
          <span className="phone-number-example old-format">966532571702</span>
          <br />
          <span className="arrow-icon">⬇</span>
          <br />
          <strong>New Format:</strong>
          <br />
          <span className="phone-number-example new-format">0536785505</span>
          <span className="info-note">
            💡 <strong>Note:</strong> All existing phone numbers have been automatically updated. 
            No action required from you, just use the new format when entering new numbers.
          </span>
        </>
      ),
      button: "Got it"
    }
  };

  useEffect(() => {
    // Only check on home page
    if (location.pathname === "/" || location.pathname === "/home") {
      const displayCount = parseInt(
        localStorage.getItem("phoneFormatModalCount") || "0"
      );

      if (displayCount < 3) {
        setOpenModal(true);
        localStorage.setItem(
          "phoneFormatModalCount",
          (displayCount + 1).toString()
        );
      }
    }
  }, [location.pathname]);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const content = modalContent[language] || modalContent.en;

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="phone-format-modal-title"
      aria-describedby="phone-format-modal-description"
      className="phone-format-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 480, md: 520 },
          maxWidth: "95vw",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          textAlign: "center",
          direction: language === "ar" ? "rtl" : "ltr",
        }}
      >
        <Typography
          id="phone-format-modal-title"
          variant="h6"
          component="h2"
          sx={{ mb: 3, fontWeight: "bold", fontSize: "1.3rem" }}
        >
          {content.title}
        </Typography>
        <Typography
          id="phone-format-modal-description"
          sx={{ mb: 3, fontSize: "1rem", lineHeight: 1.8 }}
        >
          {content.message}
        </Typography>
        <Button
          variant="contained"
          onClick={handleCloseModal}
          sx={{ px: 4, py: 1.2 }}
        >
          {content.button}
        </Button>
      </Box>
    </Modal>
  );
};

export default PhoneFormatModal;